import axios, { encodeData } from "../utils/axios";

export const fetchReferralKinds = async () => {
  const res = await axios.get("/referralKinds").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const createReferralKind = async (newReferralKind) => {
  await axios.post("/referralKinds/create", encodeData(newReferralKind));
};

export const updateReferralKind = async (updatedReferralKind) => {
  await axios.put("/referralKinds/update", encodeData(updatedReferralKind));
};

export const deleteReferralKind = async (oldReferralKind) => {
  await axios.delete("/referralKinds/delete", {
    data: encodeData(oldReferralKind),
  });
};

export const fetchReferralPdf = async (
  applicationId,
  flowId,
  applicationKindId
) => {
  const res = await axios
    .get("/referralKinds/get-referal-pdf/", {
      params: {
        applicationId: applicationId,
        flowId: flowId,
        applicationKindId: applicationKindId,
      },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};
